module.exports = __webpack_public_path__ + "img/verify-img1.6643f581.jpg";